import React from 'react';
import type { DocumentLocale } from '../utils/documentLocale';
import './LegalDocumentLanguageToggle.css';

interface LegalDocumentLanguageToggleProps {
    locale: DocumentLocale;
    onChange: (locale: DocumentLocale) => void;
}

const LegalDocumentLanguageToggle: React.FC<
    LegalDocumentLanguageToggleProps
> = ({ locale, onChange }) => {
    return (
        <div className="legal-language-toggle" role="group" aria-label="Language">
            <button
                type="button"
                className={`legal-language-btn ${locale === 'tr' ? 'active' : ''}`}
                onClick={() => onChange('tr')}
                aria-pressed={locale === 'tr'}
            >
                TR
            </button>
            <span className="legal-language-separator">|</span>
            <button
                type="button"
                className={`legal-language-btn ${locale === 'en' ? 'active' : ''}`}
                onClick={() => onChange('en')}
                aria-pressed={locale === 'en'}
            >
                EN
            </button>
        </div>
    );
};

export default LegalDocumentLanguageToggle;
